import Resource from '@/api/resources/Resource'

class LaboratoryHolidayConfigurationServices extends Resource {
    async updateLaboratoryHoliday(request, laboratoryHolidayId, laboratoryId) {
        const response = await this.axios.put(`/configuration/laboratories/${laboratoryId}/holidays/${laboratoryHolidayId}`, request)
        return response.data
    }
    async createLaboratoryHoliday(request, laboratoryId) {
        const response = await this.axios.post(`/configuration/laboratories/${laboratoryId}/holidays`, request)
        return response.data
    }
    async deleteLaboratoryHoliday(laboratoryHolidayId, laboratoryId) {
        const response = await this.axios.delete(`/configuration/laboratories/${laboratoryId}/holidays/${laboratoryHolidayId}`)
        return response.data
    }
}

export default new LaboratoryHolidayConfigurationServices()
